import React, { Component, ReactNode } from 'react'
import { connector, PanelStateProps } from './Panel.state'
import MobileHeader from '../../MobileHeader'
import Sidebar from '../Sidebar'

export interface PanelProps {
  children: ReactNode
}

type PanelCombinedProps = PanelProps & PanelStateProps

class Panel extends Component<PanelCombinedProps> {
  render () {
    return (
      <div className="bg-split">
        <div className="container mx-auto">
          <div className="flex">
            <Sidebar
              visible={this.props.sidebar}
              onClose={this.props.sidebarClose}
              onRoute={this.props.sidebarClose} />
            <div className="bg-tertiary w-full h-screen overflow-auto">
              <MobileHeader onSidebarOpen={this.props.sidebarOpen} />
              <div
                className="p-5">
                {this.props.children}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connector(Panel)
